import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    setTimeout(() => {
      this.element.classList.add("opacity-0", "scale-95");
      setTimeout(() => {
        this.element.remove();
      }, 100);
    }, 3000);
  }

  click() {
    this.element.classList.add("opacity-0", "scale-95");
    setTimeout(() => {
      this.element.remove();
    }, 100);
  }

  disconnect() {
    // Remove notice so it won't get cached by turbo
    this.element.remove();
  }
}
